// alternative-dashboard/config/treasuryLayout.config.ts
export type TreasuryWidgetSize = "half" | "full";

export interface TreasuryWidgetLayout {
  menuId: number;
  size: TreasuryWidgetSize;
}

export const TREASURY_WIDGET_LAYOUT: TreasuryWidgetLayout[] = [
  { menuId: 201, size: "half" }, // Cash Position
  { menuId: 202, size: "half" }, // Balance By Account

  { menuId: 203, size: "half" }, // Upcoming Obligations
  { menuId: 204, size: "half" }, // Quick Actions

  { menuId: 67, size: "full" }, // Statements
  { menuId: 68, size: "full" }, // Chequebook
  { menuId: 69, size: "full" }, // Balance Confirmation
];
